// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"220f0619","455":"f85db4c8","644":"d8f2b8dd"}[chunkId] + ".chunk.js";
};